import {
  Box,
  Button,
  Flex,
  HStack,
  Image,
  Text,
  VStack
} from "@chakra-ui/react";
import moment from "moment";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Loading from "../../../components/common/Loading";
import TrDashboardHeader from "../../../components/common/TrainerDashboardHeader";
import TrainerSidenav from "../../../components/trainer/courses/Sidenav";
import rarrow from "../../../img/rarrow.svg";
import { IGetAnnouncement } from "../../../models/trainee-course.model";
import trainercoursesService from "../../../services/trainer/trainercourses.service";

export const TrEachAnnouncement = () => {
  const params = useParams();
  const navigate = useNavigate();
  const course_id: any = params.course_id;
  const announcement_id: any = params.id;
  const [announcement, setAnnouncement] = useState<IGetAnnouncement | any>([]);
  const [loading, setLoading] = useState(true);
  const courseName: null | string = localStorage.getItem("courseName");

  useEffect(() => {
    if (announcement_id)
      trainercoursesService
        .getSingleAnnouncement(announcement_id)
        .then((res) => {
          setAnnouncement(res.data);
          setLoading(false);
        });
  }, [announcement_id]);

  return (
    <>
      <TrDashboardHeader />
      {loading ? (
        <Loading />
      ) : (
        <Box bg="#F9F8F8" minHeight="100vh" height={"auto"} pb={"2rem"} pt={"1.5rem"}>
          <Flex width="90%" mx="auto" pt="80px">
            <TrainerSidenav />
            <VStack width={{ lg: "80%", md: "80%", sm: "95%", base: "95%" }}>
            <HStack width={"100%"} height={"2rem"}>
              <Text as="span" fontSize={"20px"}>
              {courseName && courseName.replaceAll(/"/g, "")}
              </Text>
              <Image src={rarrow} />
              <Text as="span" fontSize={"20px"} color={"#616161"}>
                Announcements
              </Text>
            </HStack>
            <Box
              width="100%"
              mx="auto"
              pb="200px"
              pl="75px"
              pt="50px"
              bg="white"
              pr="70px"
            >
              <VStack
                justifyContent={"flex-start"}
                width={"100%"}
                alignItems={"flex-start"}
              >
                <Text
                  color="#1E1E1E"
                  fontSize="28px"
                  pb="5px"
                  fontWeight="600"
                >
                  Announcement
                </Text>
                <Button
                  py="13px"
                  px="30px"
                  width="auto"
                  mt="10px"
                  type="submit"
                  variant={"outline"}
                  fontSize={11}
                  onClick={() =>
                    navigate(`/trainer/course/${course_id}/announcement`)
                  }
                  colorScheme="red"
                  size="sm"
                >
                  BACK TO ANNOUNCEMENT
                </Button>
              </VStack>

              <Box>
                <Flex
                  pb="20px"
                  mb="30px"
                  pr="30px"
                  py="25px"
                  borderBottom="1px solid "
                  borderColor="lightgrey"
                >
                  <Box mr="45px" width="90%">
                    <Text fontWeight="600" color="#616161" fontSize="20px">
                      {announcement.title}
                    </Text>
                    <Flex
                      fontWeight="400"
                      color=" #B9B9B9"
                      mb="10px"
                      fontSize="12px"
                    >
                      posted by{" "}
                      <Text color="red" px="3px">
                        {" "}
                        {announcement.user.name}{" "}
                      </Text>{" "}
                      || {moment(announcement.created_at).fromNow()}
                    </Flex>
                    <Text
                      mb="10px"
                      fontSize="16px"
                      fontWeight="500"
                      color=" #B9B9B9"
                    >
                      {announcement.description}
                    </Text>
                  </Box>
                </Flex>
              </Box>
            </Box>
            </VStack>
          </Flex>
        </Box>
      )}
    </>
  );
};

export default TrEachAnnouncement;
